/* eslint no-param-reassign: "error" */
/* eslint-disable no-new */

// *******************************************************************************
// 0.1 - BREAKPOINT VARS
// *******************************************************************************
const breakpointSm = 767;
const breakpointMd = 1023;
const breakpointLg = 1171;

// *******************************************************************************
// 0.2 - VARIOUS FUNCTIONS
// *******************************************************************************

// Return Window Width
function windowWidth() {
  return window.innerWidth || document.documentElement.clientWidth;
}

// *******************************************************************************
// 0.3 - FUNCTIONS
// *******************************************************************************

// Attach Events
function attachEvent(selector, event, handler) {
  document.addEventListener(
    event,
    (ev) => {
      let { target } = ev;
      for (; target && target !== document; target = target.parentNode) {
        if (target.matches(selector)) {
          try {
            handler.call(target, ev);
          } catch (e) {
            console.error(e);
          }
          break;
        }
      }
    },
    false,
  );
}

// Animate
function animate(elementToAnimate, type) {
  switch (type) {
    case 'show':
      elementToAnimate.classList.add('is-visible');
      elementToAnimate.classList.remove('is-hidden');
      break;
    case 'hide':
      elementToAnimate.classList.add('is-hidden');
      elementToAnimate.classList.remove('is-visible');
      break;
    default:
      break;
  }
}

// Validate email input
const validateEmailInput = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

// *******************************************************************************
// 0.4 - DEBOUNCE FUNCTION
// *******************************************************************************

function debounce(func, wait, immediate) {
  let timeout;
  return function (...args) {
    const context = this;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// *******************************************************************************
// 0.5 - SLIDE FUNCTIONS
// *******************************************************************************

const slideUp = (target, duration) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.boxSizing = 'border-box';
  target.style.height = `${target.offsetHeight}px`;
  // eslint-disable-next-line no-unused-expressions
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const slideDown = (target, duration, displayType) => {
  target.style.removeProperty('display');

  let { display } = window.getComputedStyle(target);

  // eslint-disable-next-line no-unused-expressions
  display === 'none' ? (display = displayType) : null;
  target.style.display = display;

  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  // eslint-disable-next-line no-unused-expressions
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.height = `${height}px`;
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const slideToggle = (target, duration, displayType) => {
  /* Slide-toggle logic */

  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration, displayType);
    // eslint-disable-next-line no-else-return
  } else {
    return slideUp(target, duration, displayType);
  }
};

// *******************************************************************************
// 0.6 - Calculate Viewport units
// *******************************************************************************

function calcVh() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

const debounceCalcVh = debounce(() => {
  calcVh();
}, 50);

// Only mobile has VH calculation
window.addEventListener('DOMContentLoaded', () => {
  calcVh();
});

// window.addEventListener('resize', () => {
//   calcVh();
// });

// *******************************************************************************
// 0.7 - Smooth Scroll
// *******************************************************************************

const headerEle = document.querySelector('.header-main');

function scrollToSmoothly(pos, time = 500) {
  const currentPos = window.pageYOffset;
  let start = null;

  const step = (currentTime) => {
    start = !start ? currentTime : start;
    const progress = currentTime - start;
    const positionUpY = currentPos - ((currentPos - pos) * progress) / time;
    const positionDownY = ((pos - currentPos) * progress) / time + currentPos;

    window.scrollTo(0, currentPos < pos ? positionDownY : positionUpY);

    if (progress < time) {
      window.requestAnimationFrame(step);
    } else {
      window.scrollTo(0, pos);
    }
  };

  window.requestAnimationFrame(step);
}

// *******************************************************************************
// 0.8 - Lazy loading (https://github.com/verlok/vanilla-lazyload)
// *******************************************************************************
// if (document.querySelector('.lazyload')) {
//   const lazyLoadInstance = new LazyLoad({
//     elements_selector: '.lazyload',
//   });
// }

// This can be called whenever you need to update the lazyload instance
// lazyLoadInstance.update();

// *******************************************************************************
// 0.9 - Match Height / Equal height : https://dev.to/dhruvangg/equal-height-in-vanilla-javascript-49ch
// *******************************************************************************

function setHeight(el, val) {
  // eslint-disable-next-line no-param-reassign
  if (typeof val === 'function') val = val();
  // eslint-disable-next-line no-param-reassign
  if (typeof val === 'string') el.style.height = val;
  // eslint-disable-next-line no-param-reassign
  else el.style.height = `${val}px`;
}

const equalheight = function (container) {
  let currentTallest = 0;
  let currentRowStart = 0;
  // eslint-disable-next-line no-array-constructor
  const rowDivs = new Array();
  let $el;
  const topPosition = 0;

  Array.from(document.querySelectorAll(container)).forEach((el, i) => {
    // eslint-disable-next-line no-param-reassign
    el.style.height = 'auto';
    const topPostion = el.offsetTop;
    if (currentRowStart !== topPostion) {
      let currentDiv = 0;

      // eslint-disable-next-line no-plusplus
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        setHeight(rowDivs[currentDiv], currentTallest);
      }
      rowDivs.length = 0;
      currentRowStart = topPostion;
      currentTallest = parseFloat(getComputedStyle(el, null).height.replace('px', ''));
      rowDivs.push(el);
    } else {
      rowDivs.push(el);
      // eslint-disable-next-line operator-linebreak
      currentTallest =
        currentTallest < parseFloat(getComputedStyle(el, null).height.replace('px', ''))
          ? parseFloat(getComputedStyle(el, null).height.replace('px', ''))
          : currentTallest;
    }

    let currentDiv = 0;
    // eslint-disable-next-line no-plusplus
    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      setHeight(rowDivs[currentDiv], currentTallest);
    }
  });
};

window.addEventListener('load', () => {
  equalheight('.equal-height');
});
window.addEventListener('resize', () => {
  setTimeout(() => {
    equalheight('.equal-height');
  });
});

// *******************************************************************************
// Smooth Scroll
// *******************************************************************************

const scrollToSection = (offsetTop) => {
  // eslint-disable-next-line no-restricted-globals
  scroll({
    top: offsetTop,
    behavior: 'smooth',
  });
};

// *******************************************************************************
// Play video
// *******************************************************************************

const createEmbedVideoContainerId = () => `id_${Math.floor(Math.random() * 10000 + 1)}`;

const parseEmbedVideoValue = (value, providerOverride) => {
  const trimmed = (value || '').trim();

  if (providerOverride === 'youtube' || providerOverride === 'vimeo') {
    return { provider: providerOverride, id: trimmed };
  }

  if (/vimeo\.com/i.test(trimmed)) {
    const idMatch = trimmed.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    const hashMatch = trimmed.match(/[?&]h=([\w]+)/);

    return {
      provider: 'vimeo',
      id: idMatch ? idMatch[1] : trimmed,
      hash: hashMatch ? hashMatch[1] : null,
    };
  }

  if (/youtube\.com|youtu\.be/i.test(trimmed)) {
    const watchMatch = trimmed.match(/[?&]v=([\w-]{11})/);
    const shortMatch = trimmed.match(/youtu\.be\/([\w-]{11})/);
    const embedMatch = trimmed.match(/embed\/([\w-]{11})/);
    const id = watchMatch?.[1] || shortMatch?.[1] || embedMatch?.[1] || trimmed;

    return { provider: 'youtube', id };
  }

  if (/^\d+$/.test(trimmed)) {
    return { provider: 'vimeo', id: trimmed };
  }

  return { provider: 'youtube', id: trimmed };
};

const getVimeoWatchUrl = (vimeoId, vimeoHash) =>
  vimeoHash ? `https://vimeo.com/${vimeoId}?h=${vimeoHash}` : `https://vimeo.com/${vimeoId}`;

const getEmbedVideoPosterSrc = (image) =>
  (image.getAttribute('src') || image.getAttribute('data-src') || '').trim();

const isYoutubeAutoPosterImage = (src) => /img\.youtube\.com\/vi\//i.test(src || '');

const isSitePlaceholderPosterImage = (src) => /1x1_placeholder/i.test(src || '');

const shouldReplaceVimeoPosterImage = (image) => {
  const posterSrc = getEmbedVideoPosterSrc(image);

  if (image.classList.contains('video__image--default')) {
    return isSitePlaceholderPosterImage(posterSrc);
  }

  return isYoutubeAutoPosterImage(posterSrc) || isSitePlaceholderPosterImage(posterSrc);
};

const setEmbedVideoPosterImage = (image, thumbnailUrl) => {
  const previousSrc = getEmbedVideoPosterSrc(image);

  image.src = thumbnailUrl;

  const dataSrc = image.getAttribute('data-src');

  if (
    dataSrc &&
    (dataSrc === previousSrc || isYoutubeAutoPosterImage(dataSrc) || isSitePlaceholderPosterImage(dataSrc))
  ) {
    image.setAttribute('data-src', thumbnailUrl);
  }
};

const fetchVimeoThumbnailUrl = (vimeoId, vimeoHash) => {
  const oembedUrl = `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(getVimeoWatchUrl(vimeoId, vimeoHash))}`;

  return fetch(oembedUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Vimeo oEmbed request failed');
      }

      return response.json();
    })
    .then((data) => data.thumbnail_url || null);
};

const applyVimeoPosterFallback = () => {
  document.querySelectorAll('.video__poster').forEach((poster) => {
    const videoValue = poster.getAttribute('data-id');

    if (!videoValue) {
      return;
    }

    const providerOverride = poster.getAttribute('data-provider');
    const { provider, id, hash } = parseEmbedVideoValue(videoValue, providerOverride);

    if (provider !== 'vimeo') {
      return;
    }

    const image = poster.querySelector('.video__image img');

    if (!image || !shouldReplaceVimeoPosterImage(image) || poster.getAttribute('data-vimeo-poster-loaded')) {
      return;
    }

    poster.setAttribute('data-vimeo-poster-loaded', 'pending');

    fetchVimeoThumbnailUrl(id, hash)
      .then((thumbnailUrl) => {
        if (thumbnailUrl) {
          setEmbedVideoPosterImage(image, thumbnailUrl);
        }

        poster.setAttribute('data-vimeo-poster-loaded', 'true');
      })
      .catch((error) => {
        console.error(error);
        poster.removeAttribute('data-vimeo-poster-loaded');
      });
  });
};

const loadVimeoPlayerApi = () => {
  if (window.Vimeo?.Player) {
    return Promise.resolve();
  }

  if (!window.__vimeoPlayerApiPromise) {
    window.__vimeoPlayerApiPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://player.vimeo.com/api/player.js';
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Vimeo Player API failed to load'));
      document.head.appendChild(script);
    });
  }

  return window.__vimeoPlayerApiPromise;
};

const playYoutubeVideo = (parent, containerId, videoId) => {
  let player;

  function onPlayerReady(event) {
    event.target.playVideo();
  }

  function onPlayerStateChange(event) {
    if (event.data === 0) {
      parent.classList.remove('is-playing');
      player.stopVideo();
      player.destroy();
      player = null;
    }
  }

  player = new YT.Player(containerId, {
    videoId,
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerStateChange,
    },
  });
};

const playVimeoVideo = (parent, containerId, vimeoId, vimeoHash) => {
  const vimeoOptions = vimeoHash ? { url: getVimeoWatchUrl(vimeoId, vimeoHash) } : { id: vimeoId };

  loadVimeoPlayerApi()
    .then(() => {
      const player = new Vimeo.Player(containerId, vimeoOptions);

      player.ready().then(() => player.play());

      player.on('ended', () => {
        parent.classList.remove('is-playing');
        player.destroy();
      });
    })
    .catch((error) => {
      console.error(error);
      parent.classList.remove('is-playing');
    });
};

const VideoPlayer = (parentElem) => {
  const parent = parentElem.querySelector('.video');
  const poster = parentElem.querySelector('.video__poster');
  const videoValue = poster.getAttribute('data-id');
  const providerOverride = poster.getAttribute('data-provider');
  const { provider, id, hash } = parseEmbedVideoValue(videoValue, providerOverride);
  const containerId = createEmbedVideoContainerId();
  const container = parent.querySelector('.video__iframe-container');

  parent.classList.add('is-playing');
  container.id = containerId;

  if (provider === 'vimeo') {
    playVimeoVideo(parent, containerId, id, hash);
    return;
  }

  playYoutubeVideo(parent, containerId, id);
};

window.addEventListener('DOMContentLoaded', applyVimeoPosterFallback);
window.addEventListener('load', applyVimeoPosterFallback);

window.addEventListener('load', () => {
  document.body.classList.add('page-loaded');
});

// Add class if page takes more than 5s of loading
setTimeout(() => {
  document.body.classList.add('page-loaded');
}, 5000);

// *******************************************************************************
// Add scrollbar width
// *******************************************************************************
const getScrollbarWidth = () => {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);
  const inner = document.createElement('div');
  outer.appendChild(inner);
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  document.documentElement.style.setProperty('--scroll-width', `${scrollbarWidth}px`);
};

getScrollbarWidth();

window.addEventListener('resize', () => {
  getScrollbarWidth();
});
